<template>
    <el-drawer
      :title="title"
      :visible.sync="visible"
      :direction="direction"
      :before-close="cancel"
      :size="size"
      :wrapperClosable="false"
      :append-to-body="appendToBody"
      @close="close"
      @open="open"
      @opened="opened"
      @closed="closed"
      :custom-class="customClass + ' yun-drawer-container'"
    >
      <div class="yun-drawer-form-scroll" v-if="visible">
        <slot></slot>
      </div>
      <div class="yun-drawer-footer">
        <template v-if="footerBtnList && footerBtnList.length > 0">
          <div>
            <template v-for="(item,index) in footerBtnList">
              <template v-if="item.buttonType === 'popover'">
                <el-popover
                    :key="'$'+index"
                    placement="top"
                    :width="item.width ? item.width : null"
                    v-model="item.popoverVisible"
                    >
                    <p style="font-size:12px;"><i class="el-icon-warning" style="color:red;font-size:14px;margin-right:5px;"></i>{{item.popoverTitle}}</p>
                    <div style="text-align: right; margin: 0">
                        <el-button :loading="item.loading" :type="item.popoverTheme || 'primary'" size="mini" style="padding:5px 10px;" @click="item.callback()">{{ languaget('msg.confirmButton', '确定')}}</el-button>
                    </div>
                    <el-button
                      style="margin-left:10px"
                        slot="reference"
                        :class="item.class?item.class:null"
                        :loading="item.loading"
                        :type="item.type">
                        {{item.btnName}}
                    </el-button>
                </el-popover>
              </template>
              <template v-else>
                <el-button :key="index"
                  :class="item.class?item.class:null"
                  :type="item.type?item.type:null"
                  :loading="item.loading"
                  :disabled="item.disabled?item.disabled: false"
                  @click="item.callback()">{{item.btnName}}</el-button>
              </template>
            </template>
          </div>
        </template>
        <template v-else>
          <div>
            <el-button class="close" @click="cancel">{{ languaget('msg.cancelButton', '取消')}}</el-button>
            <el-button class="confirm" :loading="btnLoading" type="primary" @click="confirmClick('confirmClick')">{{ languaget('msg.confirmButton', '确定')}}</el-button>
          </div>
        </template>
      </div>
    </el-drawer>
</template>

<script>
export default {
  name: 'YunDrawer',
  props: {
    title: String,
    footerBtnList:{
      type: Array,
      default: () => []
    },
    visible: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'rtl'
    },
    size: {
      type: String,
      default: '672px'
    },
    // Drawer 自身是否插入至 body 元素上。嵌套的 Drawer 必须指定该属性并赋值为 true
    appendToBody:{
      type: Boolean,
      default: true
    },
    // 按钮loading
    btnLoading: {
      type: Boolean,
      default: false
    },
    // 自定义类名
    customClass: {
      type: String,
      default: 'yun-drawer-container'
    }
  },
  data() {
    return {
      saveLoading: false,
    }
  },
  methods: {
    languaget(key, defaultValue) {
      if(this.$t && typeof this.$t == 'function' && this.$t(key) && this.$t(key) != key) {
        return this.$t(key)
      }
      return defaultValue
    },
    cancel() {
      this.$emit('cancel')
    },
    confirmClick() {
      this.$emit('confirm')
    },
    open() {
      this.$emit('open')
    },
    opened() {
      this.$emit('opened')
    },
    close() {
      this.$emit('close')
    },
    closed() {
      this.$emit('closed')
    }
  }
}
</script>

<style lang="scss">
.yun-drawer-container {
  //position: relative;

  .el-drawer__body {
    padding: 0 !important;
  }

  .el-drawer__header {
    color: #333;
    border-bottom: 1px solid #e1e1e1;
    padding: 12px 16px;
    margin-bottom: 0;
  }
  .yun-drawer-footer {
    position: absolute;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    width: 100%;
    padding: 12px 16px;
    border-top: 1px solid #e1e1e1;
    background: #ffffff;
    .el-button {
      span {
        font-size: 14px;
      }
    }
  }

  .yun-drawer-form-scroll {
    overflow-y: scroll;
    height: calc(100vh - 105px);
    padding: 16px;
  }
}

</style>
